<script>
import CMSListCard from "@/views/components/cms/CMSListCard.vue";

export default {
  name: "PflegeList",
  components: {CMSListCard},
  data() {
    return {
      tableItems: null,
      tableHeader: [
        {
          title: "article",
          label: "Titel",
        },
        {
          title: "creator",
          label: "Erstellt von",
        },
        {
          title: "description",
          label: "Beschreibung",
        },
        {
          title: "Action",
          label: "Aktionen",
        }
      ]
    };
  },
}
</script>

<template>
  <CMSListCard
      title="Sonstige Informationen & Dokumente"
      new-button-name="Neue(s) Dokument/Information"
      :list-header="tableHeader"
      :category=13
      :event-to-call-options="{
        table: tableItems,
        showPath: 'Pflege',
        redirectPath: 'PflegeEdit',
        categoryId: 13,
        deletePath: 'cms/deleteArticle',
        getPath: 'cms/getArticlesByCategory',
        textDelete: 'Artikel wurde erfolgreich gelöscht!',
        textDefaultData: 'pflege'
      }"
   new-button-path="PflegeNew"></CMSListCard>
</template>

<style scoped>

</style>
